/** Independent, default-off capability for confirming an Order before payment. */
export const CHECKOUT_ORDER_FIRST_ENABLED =
  String(import.meta.env.VITE_ENABLE_PUBLIC_CHECKOUT_ORDER_FIRST ?? "false").toLowerCase() ===
  "true";
